import { render, staticRenderFns } from "./LitterRegistrationSignatures.vue?vue&type=template&id=479135a2"
import script from "./LitterRegistrationSignatures.vue?vue&type=script&lang=ts"
export * from "./LitterRegistrationSignatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports